type ExtensiveImageSizeDefinition = {
  aspectRatio: string;
  min1746: number;
  max1745: number;
  max1440: number;
  max1200: number;
  max960: number;
  max640: number;
};

type SimpleImageSizeDefinition = { aspectRatio: string; width: number };

export type ImageSizeDefinition = ExtensiveImageSizeDefinition | SimpleImageSizeDefinition;

export const isExtensiveImageSizeDefinition = (
  imageSizeDefinition: ImageSizeDefinition,
): imageSizeDefinition is ExtensiveImageSizeDefinition => {
  return 'min1746' in imageSizeDefinition;
};
